import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { callAPI } from "../../../axios";
import { CircularProgress } from "@mui/material";
import "./ServicePreview.scss";

const ITEMS_PER_PAGE = 7;

export default function RestaurantsScreen(props) {
  const { previewListRowData, closePreview: onBack } = props;

  const [loader, setLoader] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState("");

  // page index for left list
  const [page, setPage] = useState(0);
  // derive selected category details
  const [categoryDetails, setCategoryDetails] = useState({});
  const [visibleItems, setVisibleItems] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  // fetch data
  useEffect(() => {
    setLoader(true);
    callAPI(`/hotel-specials/categories/${previewListRowData?.id}`, "GET")
      .then((response) => {
        setPreviewData(response || []);
        if (response?.length) {
          setSelectedVenue(response[0]?.id);
        }
        setPage(0); // reset paging when data changes
        setTotalPages(Math.ceil(previewData.length / ITEMS_PER_PAGE))
        const startIndex = 0;
        const endIndex = startIndex + ITEMS_PER_PAGE;
        setVisibleItems(response?.slice(startIndex, endIndex))
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  }, [previewListRowData]);

  useEffect(()=>{
    const startIndex = page * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const temp = previewData.slice(startIndex, endIndex)
    setVisibleItems(temp)
    setSelectedVenue(temp?.length?temp[0]?.id:"")
  },[page])

  useEffect(() => {
    const temp = previewData?.find((data) => data?.id === selectedVenue);
    if (temp) {
      setCategoryDetails(temp);
    }
    setTotalPages(Math.ceil(previewData.length / ITEMS_PER_PAGE))
  }, [selectedVenue, previewData]);

  const handleViewMore = () => {
    if (page < totalPages - 1) {
      setPage((p) => p + 1);
    } else {
      // optional: loop back to first page
      setPage(0);
    }
  };

  return (
    <div className="screen">
      {loader && (
        <div className="circular-progress">
          <CircularProgress />
        </div>
      )}

      {/* dynamic background from API */}
      <div
        className="bg"
        style={{ backgroundImage: `url(${categoryDetails?.bgImageUrl})` }}
      />
      <div className="overlay" />

      {/* back button top-left */}
      <button className="back-button" onClick={onBack}>
      <svg width="24" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
      </button>

      <div className="layout">
        {/* Sidebar with paging */}
        <div className="sidebar">
          {visibleItems?.map((r) => (
            <button
              key={r?.id}
              className={`sidebar-item ${r?.id === selectedVenue ? "sidebar-item-active" : ""}`}
              onClick={() => setSelectedVenue(r?.id)}
            >
              {r?.categoryName}
            </button>
          ))}

          {previewData.length > ITEMS_PER_PAGE && (
            // <div className="content-footer">
            <button className="view-more-btn" onClick={handleViewMore}>
              {page>0?"Go Back":"View More"}
            </button>
            // </div>
          )}
        </div>

        {/* Right content */}
        <div className="content">
          <div className="content-header text-capitalize">{previewListRowData?.menuName}</div>

          <div className="content-card">
            <div className="card-text">
              <h2 className="card-title">{categoryDetails?.categoryName}</h2>
              <p className="card-desc">{categoryDetails?.description}</p>

              <div className="card-hours">
                <div className="hours-title">{categoryDetails?.featureTitle}</div>
                {categoryDetails?.featureTitle && categoryDetails?.featureSet?.map((feature, index) => {
                return (
                  <div key={index} className="hours-row">
                    <span>{feature?.featureKey}</span>
                    <span className="hours-colon">:</span>
                    <span>{feature?.featureValue}</span>
                  </div>
                  )}
              )}
              </div>
            </div>

            {categoryDetails?.qrCode?<div className="card-qr-area">
              <div className="card-qr">
                <QRCodeSVG
                  value={categoryDetails?.qrCode}
                  size={140}
                  bgColor="#ffffff"
                  fgColor="#000000"
                />
              </div>
            </div>:<></>}
          </div>

          <div className="content-footer">
            <button className="view-gallery-btn">View Gallery</button>
          </div>
        </div>
      </div>
    </div>
  );
}
